import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSourcingConfig } from "../../contexts/SourcingConfigContext";
import Loader from "../../components/Loader";

/**
 * Route guard for sourcing/outreach pages. Renders the nested routes only when
 * sourcing is enabled for the org; otherwise redirects to the dashboard of the
 * portal the user is actually in. While the config is still loading, shows a
 * loader instead of flashing the page or a premature redirect.
 */
const RequireSourcing = () => {
  const { sourcingEnabled, loading } = useSourcingConfig();
  const location = useLocation();

  if (loading) return <Loader />;
  if (!sourcingEnabled) {
    const portal = location.pathname.startsWith("/hr") ? "hr" : "org-admin";
    return <Navigate to={`/${portal}/dashboard`} replace />;
  }

  return <Outlet />;
};

export default RequireSourcing;
